export enum ConfirmLpsRoutesEnum {
    MODULE_ACCESS = 'View',
    CONFIRM_LPS_ROUTES_GRID_VIEW = 'Confirm_LPS_Routes_Grid_View',
    CONFIRM_LPS_ROUTES_GRID_EDIT = 'Confirm_LPS_Routes_Grid_Edit',
}
